export const ValidateSettings = (payload) => {
  if (!payload.businessName) {
    return {
      error: "Business Name cannot be empty",
    };
  }
  // if (!payload.displayName) {
  //   return {
  //     error: "Display name cannot be empty",
  //   };
  // }
  if (!payload.contactNumber || payload.contactNumber.length < 10) {
    return {
      error: "Contact number is invalid",
    };
  }
  // if (!payload.email) {
  //   return {
  //     error: "Email cannot be empty",
  //   };
  // }
  if (!payload.addressLine1) {
    return {
      error: "Address line one cannot be empty",
    };
  }
  // if (!payload.addressLine2) {
  //   return {
  //     error: "Address line 2 cannot be empty",
  //   };
  // }
  // if (!payload.pincode) {
  //   return {
  //     error: "Pincode cannot be empty",
  //   };
  // }
  if (!payload.gstNumber) {
    return {
      error: "GST number cannot be empty",
    };
  }
  if (!payload.logo) {
    return {
      error: "Logo cannot be empty",
    };
  }
};
